export const FIELD_TYPE_CHOICE = 'choice'
export const FIELD_TYPE_ENUM = 'enum'
export const FIELD_TYPE_IDENTITY_TYPE = 'entity_identity'
